// Create a context
import React, { createContext, useContext, useState, ReactNode } from "react";

type GlobalStateContextType = {
  LogInUserName: string;
  setLogInUserName: Function;
  MNVMoverID: number;
  setMNVMoverID: Function;
  IsContractor: boolean;
  setIsContractor: Function;
  RolesList: any;
  setRolesList: Function;
  LogInUserImage: string;
  setLogInUserImage: Function;
  UpdateNotificationCount: any;
  setUpdateNotificationCount: Function;
  LogInUserRole: string;
  setLogInUserRole: Function;
  ManageAdmin: boolean;

  setManageAdmin: Function;
  NotificationObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
  };
  setNotificationObject: Function;
  ConfirmationModalObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
    ID: number;
    SelectedID: number;
    OtherID: number;
  };
  setConfirmationModalObject: Function;

  IsPorter: boolean;
  setIsPorter: Function;

  IsDriverLoggedIn: boolean;
  setIsDriverLoggedIn: Function;

  IsHelperLoggedIn: boolean;
  setIsHelperLoggedIn: Function;

  UserMobile: string;
  setUserMobile: Function;

  UserEmail: string;
  setUserEmail: Function;

  LoggedInUserID: number;
  setLoggedInUserID: Function;

  ShowTimeEntryIsPendingModalData: any;
  setShowTimeEntryIsPendingModalData: Function;

  ShowTimeEntryIsPendingModal: boolean;
  setShowTimeEntryIsPendingModal: Function;

  ManageObject: {
    FirstName: string;
    LastName: string;
    UserName: string;
    ImageURL: string;
    RoleName: string;
    MasterAdmin: number;
    SemiAdmin: number;
    Driver: number;
    Helper: number;
    Porter: number;
    Client: number;
    Affiliate: number;
  };
  setManageObject: Function;
};

const GlobalStateContext = createContext<GlobalStateContextType | undefined>(
  undefined,
);

export const GlobalStateProvider = ({ children }: any) => {
  const [LogInUserName, setLogInUserName] = useState<string>("");
  const [MNVMoverID, setMNVMoverID] = useState<number>(-1);
  const [IsContractor, setIsContractor] = useState<boolean>(true);
  const [RolesList, setRolesList] = useState<any>({});
  const [LogInUserImage, setLogInUserImage] = useState<string>("");
  const [LogInUserRole, setLogInUserRole] = useState<string>("");
  const [ManageAdmin, setManageAdmin] = useState<boolean>(false);
  const [UpdateNotificationCount, setUpdateNotificationCount] =
    useState<boolean>(false);

  const [LoggedInUserID, setLoggedInUserID] = useState<number>(-1);
  const [IsPorter, setIsPorter] = useState<boolean>(true);
  const [IsDriverLoggedIn, setIsDriverLoggedIn] = useState<boolean>(false);
  const [IsHelperLoggedIn, setIsHelperLoggedIn] = useState<boolean>(false);

  const [UserMobile, setUserMobile] = useState<string>("");
  const [UserEmail, setUserEmail] = useState<string>("");

  const [NotificationObject, setNotificationObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
  });
  const [ConfirmationModalObject, setConfirmationModalObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
    ID: 0,
    SelectedID: 0,
    OtherID: 0,
  });

  const [ShowTimeEntryIsPendingModalData, setShowTimeEntryIsPendingModalData] =
    useState<any>([]);
  const [ShowTimeEntryIsPendingModal, setShowTimeEntryIsPendingModal] =
    useState<boolean>(false);

  const [ManageObject, setManageObject] = useState({
    FirstName: "",
    LastName: "",
    UserName: "",
    ImageURL: "",
    RoleName: "",
    MasterAdmin: 0,
    SemiAdmin: 0,
    Driver: 0,
    Helper: 0,
    Porter: 0,
    Client: 0,
    Affiliate: 0,
  });

  return (
    <GlobalStateContext.Provider
      value={{
        LogInUserName,
        setLogInUserName,
        LoggedInUserID,
        setLoggedInUserID,
        IsPorter,
        setIsPorter,
        IsDriverLoggedIn,
        setIsDriverLoggedIn,
        IsHelperLoggedIn,
        setIsHelperLoggedIn,
        UserMobile,
        setUserMobile,
        UserEmail,
        setUserEmail,
        MNVMoverID,
        setMNVMoverID,
        IsContractor,
        setIsContractor,
        RolesList,
        setRolesList,
        LogInUserImage,
        setLogInUserImage,
        LogInUserRole,
        setLogInUserRole,
        ManageAdmin,
        setManageAdmin,
        NotificationObject,
        setNotificationObject,
        ConfirmationModalObject,
        setConfirmationModalObject,
        UpdateNotificationCount,
        setUpdateNotificationCount,
        ManageObject,
        setManageObject,
        ShowTimeEntryIsPendingModalData,
        setShowTimeEntryIsPendingModalData,
        ShowTimeEntryIsPendingModal,
        setShowTimeEntryIsPendingModal,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
